/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSelectedAnyCondition
 */
export interface ControlSelectedAnyCondition {
    /**
     * 
     * @type {string}
     * @memberof ControlSelectedAnyCondition
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSelectedAnyCondition
     */
    question_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlSelectedAnyCondition
     */
    option_ids: Array<string>;
}

/**
 * Check if a given object implements the ControlSelectedAnyCondition interface.
 */
export function instanceOfControlSelectedAnyCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "question_id" in value;
    isInstance = isInstance && "option_ids" in value;

    return isInstance;
}

export function ControlSelectedAnyConditionFromJSON(json: any): ControlSelectedAnyCondition {
    return ControlSelectedAnyConditionFromJSONTyped(json, false);
}

export function ControlSelectedAnyConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSelectedAnyCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'question_id': json['question_id'],
        'option_ids': json['option_ids'],
    };
}

export function ControlSelectedAnyConditionToJSON(value?: ControlSelectedAnyCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'question_id': value.question_id,
        'option_ids': value.option_ids,
    };
}

